var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_main_logo"},[_c('a',{staticClass:"header_main_logo_href",attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();_vm.$nuxt.$emit('close-mobile-menu');_vm.$router.push('/')}}},[_c('img',{attrs:{"src":require("@/assets/s-images/logo-sushiset-svg.svg"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }